import React from 'react';
import { NumberInput, maxValue, minValue, number, required, useInput, useTranslate } from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Api } from '@mui/icons-material';
import { ApiOperationsPicker } from './ApiOperationsPicker';
import { VENDOR_API_LIMIT_BOUNDS, normalizeSelection, wholeNumber } from './apiAccessOperations';

const controlValidators = [
    required(),
    number(),
    wholeNumber(),
    minValue(VENDOR_API_LIMIT_BOUNDS.control.min),
    maxValue(VENDOR_API_LIMIT_BOUNDS.control.max),
];

const readValidators = [
    required(),
    number(),
    wholeNumber(),
    minValue(VENDOR_API_LIMIT_BOUNDS.read.min),
    maxValue(VENDOR_API_LIMIT_BOUNDS.read.max),
];

const OperationsField = () => {
    const translate = useTranslate();
    const { field } = useInput({ source: 'apiAllowedOperations', defaultValue: [] });
    return (
        <ApiOperationsPicker
            value={normalizeSelection(field.value)}
            onChange={field.onChange}
            translate={translate}
        />
    );
};

export const ApiAccessSection = () => {
    const translate = useTranslate();

    return (
        <Card sx={{ mb: { xs: 2, sm: 3 }, overflow: 'hidden' }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Api sx={{ mr: 2, color: '#00C853' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                        {translate('resources.vendors.sections.apiAccess')}
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                    {translate('resources.vendors.apiAccess.help')}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <NumberInput
                            source="apiControlLimitPerMinute"
                            label={translate('resources.vendors.fields.apiControlLimitPerMinute')}
                            defaultValue={VENDOR_API_LIMIT_BOUNDS.control.default}
                            min={VENDOR_API_LIMIT_BOUNDS.control.min}
                            max={VENDOR_API_LIMIT_BOUNDS.control.max}
                            step={1}
                            validate={controlValidators}
                            helperText={translate('resources.vendors.apiAccess.controlLimitHelperText')}
                            fullWidth
                        />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <NumberInput
                            source="apiReadLimitPerMinute"
                            label={translate('resources.vendors.fields.apiReadLimitPerMinute')}
                            defaultValue={VENDOR_API_LIMIT_BOUNDS.read.default}
                            min={VENDOR_API_LIMIT_BOUNDS.read.min}
                            max={VENDOR_API_LIMIT_BOUNDS.read.max}
                            step={1}
                            validate={readValidators}
                            helperText={translate('resources.vendors.apiAccess.readLimitHelperText')}
                            fullWidth
                        />
                    </Box>
                </Box>

                <OperationsField />
            </CardContent>
        </Card>
    );
};
